const SHORT_DAYS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
const SHORT_MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

// Returns date formatted as "Mar 18 Mai 2026" (day-of-week day month year)
export function formatDateMedium(d) {
  const date = new Date(d);
  const dayOfWeek = SHORT_DAYS[date.getDay()];
  const day = date.getDate();
  const month = SHORT_MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${dayOfWeek} ${day} ${month} ${year}`;
}
